import React, { Component } from 'react'
import { connect } from 'react-redux'
import Tinymce from './Tinymce'
import { Field, reduxForm } from 'redux-form'
import { updatePlan, planningFormInitialized } from '../actions'

class PlanningForm extends Component {
  componentWillMount() {
    this.initializeForm()
  }
  componentWillUpdate() {
    const { plans } = this.props
    if(plans.initForm){
      this.initializeForm()
    }
  }
  initializeForm() {
    const { initialize, planningFormInitialized } = this.props
    initialize(this.initializeValues(this.props))
    planningFormInitialized()
  }
  initializeValues(props) {
    const { teams, plans, match, user } = props
    const planId = plans.selectedPlanId
    const team = (match.params.id && teams[match.params.id]) || (user.admin && match.params.id === 'format') ? match.params.id : user.uid
    const planData = plans.planData[planId]
    const planningFormat = planData.format ? planData.format.plan : ""
    const plan = 
      (planData[team] && planData[team].plan)? planData[team].plan 
      : team === 'format'? planningFormat
      : planningFormat
    return({ 
      planId,
      team,
      plan
    })
  }
  render() {
    const { user, teams, handleSubmit, updatePlan, plans, change } = this.props
    const formValues = this.initializeValues(this.props)
    return (
      <div>
        <h3>{formValues.team === user.uid? user.realName : teams[formValues.team]['name']}</h3>
        <form onSubmit={handleSubmit(values => updatePlan(values))} >
          <Field name="planId" component="input" type="hidden" />
          <Field name="plan" component="input" type="hidden" />
          <Field name="team" component="input" type="hidden" />
          <div className="field">
            <div className="control">
              {plans.planParams[plans.selectedPlanId].editable && !plans.initForm?
                <Tinymce
                  init={{ 
                    height: 400,
                    plugins: 'autolink, lists', 
                    toolbar: 'styleselect bold numlist bullist removeformat',
                    style_formats: [
                      { title: '■ Red', inline: 'span', styles: { color: '#f00' } }
                    ]
                  }}
                  initialValue={formValues.plan}
                  onChange={ e => { change('plan',  e.target.getContent()) } }
                />
              : 
                <div dangerouslySetInnerHTML={{__html: formValues.plan}}></div>
              }
            </div>
          </div>
          <div className="field is-clearfix">
            <button type="submit" className="button is-pulled-right">登 録</button>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(
  state => ({
    user: state.user,
    teams: state.organization.teams,
    plans: state.plans
  }),
  { updatePlan, planningFormInitialized }
)(reduxForm({ form: 'planning' })(PlanningForm))



// WEBPACK FOOTER //
// ./src/components/PlanningForm.js